module.exports = __webpack_public_path__ + "b46f8792f1641fc6927137c0f162e46c.svg";